import { MDBTable, MDBTableBody } from "mdbreact";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

function AgronomicsModal({ modal, toggleCriteria }) {
  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggleCriteria}
        style={{ maxWidth: "800px" }}
        centered
      >
        <ModalHeader toggle={toggleCriteria}>
          <h5 style={{ fontWeight: "bold" }}>Agronomics Criteria</h5>
        </ModalHeader>
        <ModalBody>
          <table className="table table-bordered">
            <MDBTableBody>
              <tr>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Item
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Criteria
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Score
                </th>
              </tr>
              <tr>
                <td>Ideal Vs Required Inputs</td>
                <td>
                  <tr>Equal</tr>
                  <tr>Less then designed</tr>
                  <tr>More designed</tr>
                </td>
                <td>
                  <tr>3</tr>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>
              <tr>
                <td>Delta between avg. produced price vs avg. cost</td>
                <td>
                  <tr>{"<100 %"}</tr>
                  <tr>{">=100 %"}</tr>
                  <tr>{">=150 %"}</tr>
                  <tr>{">=200 %"}</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>3</tr>
                  <tr>4</tr>
                </td>
              </tr>
              <tr>
                <td>Type of Soil</td>
                <td>
                  <tr>Stony/Sandy</tr>
                  <tr>Clay Hard</tr>
                  <tr>Clay soft</tr>
                  <tr>Loam</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>3</tr>
                  <tr>4</tr>
                </td>
              </tr>
              <tr>
                <td>Type of Irrigation</td>
                <td>
                  <tr>Rainfed</tr>
                  <tr>Canal Water</tr>
                  <tr>Tube well</tr>
                  <tr>Canal Water + Tube well</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>3</tr>
                  <tr>4</tr>
                </td>
              </tr>
              <tr>
                <td>Previous Experience with same crop</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>1</tr>
                </td>
              </tr>

              <tr>
                <td>Use of Certified Seed</td>
                <td>
                  <tr>Never</tr>
                  <tr>Sometimes</tr>
                  <tr>Always</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>4</tr>
                </td>
              </tr>

              <tr>
                <td>Use of recommended phosphate fertilizer</td>
                <td>
                  <tr>Never</tr>
                  <tr>Sometimes</tr>
                  <tr>Always</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>4</tr>
                </td>
              </tr>

              <tr>
                <td>Amount of Urea Application</td>
                <td>
                  <tr>Minimum</tr>
                  <tr>Adequate for average yield</tr>
                  <tr>Adequate for good yield</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  {/* <br/> */}
                  <tr>4</tr>
                </td>
              </tr>

              <tr>
                <td>Application of Pesticides</td>
                <td>
                  <tr>Only if there's infestation</tr>
                  <tr>Prevention</tr>
                </td>
                <td>
                  <tr>2</tr>
                  {/* <br/> */}
                  <tr>4</tr>
                </td>
              </tr>

              <tr>
                <td>Avg. Yield of Previous Crop</td>
                <td>
                  <tr>{"< 90 % CYI (crop Index)"}</tr>
                  <tr>{">= CYI (crop Index)"}</tr>
                  <tr>{"< 90 % Dist. Avg."}</tr>
                  <tr>{">= Distict Avg."}</tr>
                </td>
                <td>
                  <tr>1</tr>
                  {/* <br/> */}
                  <tr>2</tr>
                  <tr>3</tr>
                  <tr>4</tr>
                </td>
              </tr>

              <tr>
                <td>Availability of latest irrigation system (Drip,Solar)</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>
            </MDBTableBody>
          </table>
        </ModalBody>
        {/* <ModalFooter> */}
        {/* <Button color="secondary" onClick={toggleCriteria}>
            Cancel
          </Button> */}
        {/* </ModalFooter> */}
      </Modal>
    </>
  );
}

export default AgronomicsModal;
